export const UMB_MEDIA_URL_REPOSITORY_ALIAS = 'Umb.Repository.Media.Url';
export const UMB_MEDIA_URL_STORE_ALIAS = 'Umb.Store.MediaUrl';
